import './AnnouncementBar.scss';

import { mdiClose, mdiInformationOutline } from '@mdi/js';
import type { AnnouncementToRender } from 'common/models';
import Icon from 'components/Icon/Icon';
import React from 'react';

interface Props {
  announcement: AnnouncementToRender;
  onDismiss: () => void;
}

const AnnouncementBar: React.FC<Props> = (props): React.ReactElement => {
  const { announcement, onDismiss } = props;

  return (
    <div className={`AnnouncementBar ${announcement.type}`}>
      <div className="AnnouncementBar_content">
        <div className="AnnouncementBar_contentInner">
          <div className="AnnouncementsList_icon">
            <Icon path={mdiInformationOutline} />
          </div>
          <div>
            <div className="AnnouncementBar_content-title">{announcement.title}</div>
            <div className="AnnouncementBar_content-description">{announcement.description}</div>
          </div>
        </div>
        <Icon onClick={onDismiss} className="AnnouncementBar_dismiss" path={mdiClose} />
      </div>
    </div>
  );
};

export default AnnouncementBar;
